import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { HeaderModule } from 'src/app/shared/header/header.module';

import { AppRoutingErrorRoutingModule } from './app-routing-error/app-routing-error-routing.module';
import { AppRoutingErrorComponent } from './app-routing-error/app-routing-error.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ResolveBaumusterComponent } from './error-page/error-types/resolve-baumuster/resolve-baumuster.component';

@NgModule({
  imports: [
    HeaderModule,
    CommonModule,
    AppRoutingErrorRoutingModule,
    ResolveBaumusterComponent,
    ErrorPageComponent,
    AppRoutingErrorComponent
  ],
  exports: [ResolveBaumusterComponent, ErrorPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppErrorModule {}
